/* ============================================================
   AOREX theme JS. All public functions are prefixed AOREX_ so they
   don't collide with anything else Shopify (or an app) puts on the
   page. window.AOREX (routes, money format, whatsapp number) and
   window.AOREX_PRODUCT (current product, on product pages only)
   are set inline by the Liquid templates.
   ============================================================ */

/* ============================================================
   PRELOADER
   A quick "checking in" moment before the site reveals itself,
   built from the same boarding-pass language as the rest of the
   brand rather than a generic spinner. Skips instantly if the
   visitor has reduced motion enabled.
   ============================================================ */
(function runPreloader(){
  const el = document.getElementById('preloader');
  if(!el) return;
  let alreadyShown = false;
  try{ alreadyShown = sessionStorage.getItem('aorex_preloader_shown') === '1'; }catch(e){ alreadyShown = false; }
  if(alreadyShown){
    el.style.display = 'none';
    return;
  }
  try{ sessionStorage.setItem('aorex_preloader_shown', '1'); }catch(e){}
  let prefersReduced = false;
  try{ prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){ prefersReduced = false; }
  if(prefersReduced){
    el.style.display = 'none';
    return;
  }
  const forceHide = setTimeout(()=>{ el.classList.add('leaving'); setTimeout(()=>{ el.style.display='none'; }, 700); }, 4000);
  const barcodeEl = document.getElementById('preloader-barcode');
  let bars = '';
  for(let i=0;i<22;i++){ bars += `<span style="height:${6+Math.random()*16}px;"></span>`; }
  barcodeEl.innerHTML = bars;

  const fill = document.getElementById('preloader-fill');
  const pct = document.getElementById('preloader-pct');
  const statusText = document.getElementById('preloader-status-text');
  let progress = 0;
  const tick = setInterval(()=>{
    progress += Math.random()*16 + 8;
    if(progress >= 100){
      progress = 100;
      clearInterval(tick);
      clearTimeout(forceHide);
      statusText.textContent = 'Boarding';
      fill.style.width = '100%';
      pct.textContent = '100%';
      setTimeout(()=>{
        el.classList.add('leaving');
        setTimeout(()=>{ el.style.display = 'none'; }, 700);
      }, 380);
      return;
    }
    fill.style.width = progress + '%';
    pct.textContent = Math.floor(progress) + '%';
  }, 200);
})();

/* ---------------- THEME (dark/light) ---------------- */
const SUN_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
const MOON_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5Z"/></svg>';
let AOREX_theme = localStorage.getItem('aorex_theme') || 'dark';
function AOREX_applyTheme(){
  document.documentElement.setAttribute('data-theme', AOREX_theme);
  const btn = document.getElementById('theme-toggle-btn');
  if(btn) btn.innerHTML = AOREX_theme==='dark' ? SUN_ICON : MOON_ICON;
  const label = document.getElementById('theme-toggle-mobile-label');
  if(label) label.textContent = AOREX_theme==='dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode';
}
function AOREX_toggleTheme(){
  AOREX_theme = AOREX_theme==='dark' ? 'light' : 'dark';
  try{ localStorage.setItem('aorex_theme', AOREX_theme); }catch(e){}
  AOREX_applyTheme();
}

/* ---------------- MOBILE MENU ---------------- */
function AOREX_toggleMobileMenu(open){
  document.getElementById('mobile-menu').classList.toggle('open', open);
}

/* ---------------- CART (real Shopify Ajax Cart API) ---------------- */
function AOREX_moneyFmt(cents){
  const amount = (cents/100).toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2});
  return (window.AOREX && window.AOREX.moneyFormat ? window.AOREX.moneyFormat : '₹{{amount}}').replace(/\{\{.*?\}\}/, amount);
}
async function AOREX_fetchCart(){
  const res = await fetch(window.AOREX.routes.cartJson);
  return res.json();
}
async function AOREX_addToCart(variantId, quantity){
  quantity = quantity || 1;
  const res = await fetch(window.AOREX.routes.cartAdd, {
    method: 'POST',
    headers: {'Content-Type':'application/json', 'Accept':'application/json'},
    body: JSON.stringify({items:[{id: variantId, quantity: quantity}]})
  });
  if(!res.ok){
    const err = await res.json().catch(()=>({}));
    alert((err && err.message) || 'Could not add that to your cart. It may be out of stock.');
    return null;
  }
  await AOREX_renderCartCount();
  await AOREX_renderCart();
  AOREX_toggleCart(true);
  return res.json();
}
async function AOREX_bundleBothToCart(variantIdA, variantIdB){
  const res = await fetch(window.AOREX.routes.cartAdd, {
    method: 'POST',
    headers: {'Content-Type':'application/json', 'Accept':'application/json'},
    body: JSON.stringify({items:[{id: variantIdA, quantity:1}, {id: variantIdB, quantity:1}]})
  });
  if(!res.ok){ alert('Could not add both to your cart — one may be out of stock.'); return; }
  await AOREX_renderCartCount();
  await AOREX_renderCart();
  AOREX_toggleCart(true);
}
function AOREX_quickAdd(variantId){
  AOREX_addToCart(variantId, 1);
}
async function AOREX_updateQty(key, quantity){
  await fetch(window.AOREX.routes.cartChange, {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: quantity})
  });
  await AOREX_renderCartCount();
  await AOREX_renderCart();
}
async function AOREX_renderCartCount(){
  const cart = await AOREX_fetchCart();
  const badge = document.getElementById('cart-count');
  if(badge){ badge.textContent = cart.item_count; badge.style.display = cart.item_count>0 ? 'flex' : 'none'; }
  const drawerCount = document.getElementById('cart-drawer-count');
  if(drawerCount) drawerCount.textContent = cart.item_count;
}
async function AOREX_renderCart(){
  const cart = await AOREX_fetchCart();
  const itemsEl = document.getElementById('cart-items');
  const footEl = document.getElementById('cart-footer');
  if(!itemsEl || !footEl) return;
  if(cart.item_count === 0){
    itemsEl.innerHTML = `
      <div style="text-align:center;padding:60px 10px;">
        <div class="eyebrow" style="justify-content:center;">Empty Route</div>
        <h3 style="font-family:var(--font-display);font-size:26px;text-transform:uppercase;margin-top:12px;">Your Route Is Empty.</h3>
        <p style="color:var(--gray);margin-top:10px;font-size:14px;">Every journey starts somewhere. Go find your pair.</p>
      </div>`;
    footEl.innerHTML = `<a class="btn btn-primary btn-block" href="/collections/all">Shop New Drops</a>`;
    return;
  }
  itemsEl.innerHTML = cart.items.map(l => `
    <div style="display:flex;gap:12px;padding:16px 0;border-bottom:1px dashed var(--border-strong);">
      <div class="shoe-art" style="width:78px;height:78px;flex-shrink:0;">
        ${l.image ? `<img src="${l.image}&width=160" style="width:100%;height:100%;object-fit:cover;" alt="">` : ''}
      </div>
      <div style="flex:1;min-width:0;">
        <div style="display:flex;justify-content:space-between;gap:8px;">
          <span style="font-weight:600;font-size:14px;">${l.product_title}</span>
          <button onclick="AOREX_updateQty('${l.key}', 0)" aria-label="Remove" style="background:none;border:none;color:var(--gray);"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg></button>
        </div>
        <div class="mono-tag" style="margin-top:4px;">${(l.variant_title||'').toUpperCase()}</div>
        <div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;">
          <div style="display:flex;align-items:center;border:1px solid var(--border-strong);border-radius:2px;">
            <button onclick="AOREX_updateQty('${l.key}', ${l.quantity-1})" style="width:28px;height:28px;background:none;border:none;color:var(--off-white);">−</button>
            <span style="width:24px;text-align:center;font-size:13px;">${l.quantity}</span>
            <button onclick="AOREX_updateQty('${l.key}', ${l.quantity+1})" style="width:28px;height:28px;background:none;border:none;color:var(--off-white);">+</button>
          </div>
          <span style="font-weight:700;font-size:14px;">${AOREX_moneyFmt(l.final_line_price)}</span>
        </div>
      </div>
    </div>`).join('');
  footEl.innerHTML = `
    <div style="display:flex;justify-content:space-between;font-size:14px;margin-bottom:8px;"><span style="color:var(--gray);">Subtotal</span><span>${AOREX_moneyFmt(cart.total_price)}</span></div>
    <div style="display:flex;justify-content:space-between;font-size:12px;color:var(--gray);margin-bottom:16px;"><span>Shipping</span><span>Calculated at checkout</span></div>
    <a class="btn btn-primary btn-block" href="/checkout">Checkout →</a>
    <button class="btn btn-outline btn-block" style="margin-top:10px;" onclick="AOREX_toggleCart(false)">Continue Shopping</button>`;
}
function AOREX_toggleCart(open){
  document.getElementById('cart-drawer').style.transform = open ? 'translateX(0)' : 'translateX(100%)';
  document.getElementById('cart-backdrop').style.display = open ? 'block' : 'none';
  if(open) AOREX_renderCart();
}

/* ---------------- WISHLIST (client-side only — no Shopify backend for this) ---------------- */
function AOREX_getWishlist(){
  try{ return JSON.parse(localStorage.getItem('aorex_wishlist')||'[]'); }catch(e){ return []; }
}
function AOREX_toggleWishlist(productId, btnEl){
  let list = AOREX_getWishlist();
  const idx = list.findIndex(x=>x.id===productId);
  if(idx>-1){
    list.splice(idx,1);
  }else{
    const title = window.AOREX_PRODUCT ? window.AOREX_PRODUCT.title : (btnEl ? btnEl.closest('.product-card')?.querySelector('.pname')?.textContent : '');
    const url = window.AOREX_PRODUCT ? window.AOREX_PRODUCT.url : (btnEl ? btnEl.closest('.product-card')?.querySelector('a,[onclick]')?.getAttribute('onclick') : '');
    list.push({id: productId, title: title || 'Saved item', url: window.location.pathname});
  }
  try{ localStorage.setItem('aorex_wishlist', JSON.stringify(list)); }catch(e){}
  AOREX_renderWishlistCount();
}
function AOREX_renderWishlistCount(){
  const badge = document.getElementById('wishlist-count');
  if(!badge) return;
  const list = AOREX_getWishlist();
  badge.textContent = list.length;
  badge.style.display = list.length>0 ? 'flex' : 'none';
}
function AOREX_toggleWishlistDrawer(open){
  const drawer = document.getElementById('wishlist-drawer');
  const backdrop = document.getElementById('wishlist-backdrop');
  if(!drawer) return;
  drawer.style.transform = open ? 'translateX(0)' : 'translateX(100%)';
  backdrop.style.display = open ? 'block' : 'none';
  if(open) AOREX_renderWishlistDrawer();
}
function AOREX_renderWishlistDrawer(){
  const el = document.getElementById('wishlist-items');
  if(!el) return;
  const list = AOREX_getWishlist();
  if(list.length===0){
    el.innerHTML = `
      <div style="text-align:center;padding:40px 10px;">
        <div class="eyebrow" style="justify-content:center;">Nothing Saved Yet</div>
        <h3 style="font-family:var(--font-display);font-size:22px;text-transform:uppercase;margin-top:10px;">Your Wishlist Is Empty.</h3>
        <p style="color:var(--gray);margin-top:8px;font-size:13px;">Tap the heart on anything you like and it will show up here.</p>
      </div>`;
    return;
  }
  el.innerHTML = list.map(item => `
    <a href="${item.url}" style="display:block;padding:14px 0;border-bottom:1px solid var(--border);color:var(--off-white);">
      <strong style="font-size:14px;">${item.title}</strong>
    </a>`).join('');
}

/* ---------------- PRODUCT PAGE: variant selection ---------------- */
let AOREX_selectedOptions = {};
function AOREX_initVariantPicker(){
  if(!window.AOREX_PRODUCT) return;
  const current = window.AOREX_PRODUCT.variants.find(v => v.id == document.getElementById('pdp-variant-id')?.value)
    || window.AOREX_PRODUCT.variants[0];
  if(!current) return;
  AOREX_selectedOptions = {0: current.option1, 1: current.option2, 2: current.option3};
}
function AOREX_selectOption(optionIndex, value, btnEl){
  AOREX_selectedOptions[optionIndex] = value;
  document.querySelectorAll(`[data-option-index="${optionIndex}"]`).forEach(b=>{
    const active = b.dataset.value === value;
    if(b.style.borderRadius === '50%'){ // color swatch
      b.style.borderColor = active ? 'var(--off-white)' : 'transparent';
    } else { // size button
      b.style.borderColor = active ? 'var(--red)' : 'var(--border-strong)';
    }
  });
  const match = window.AOREX_PRODUCT.variants.find(v =>
    [v.option1, v.option2, v.option3].filter((x,i)=> Object.prototype.hasOwnProperty.call(AOREX_selectedOptions,i)).every((val,i)=> val === AOREX_selectedOptions[i])
  );
  if(match){
    document.getElementById('pdp-variant-id').value = match.id;
    const priceEl = document.getElementById('pdp-price');
    const addPriceEl = document.getElementById('pdp-add-price');
    const money = AOREX_moneyFmt(match.price);
    if(priceEl) priceEl.textContent = money;
    if(addPriceEl) addPriceEl.textContent = money;
    const colorNameEl = document.getElementById('pdp-color-name');
    if(colorNameEl && optionIndex==0) colorNameEl.textContent = value;
    const addBtn = document.getElementById('pdp-add-btn');
    if(addBtn){
      addBtn.disabled = !match.available;
      addBtn.innerHTML = match.available ? `Add to Cart · <span id="pdp-add-price">${money}</span>` : 'Sold Out';
    }
    const img = match.featured_image;
    if(img){
      const mainImg = document.getElementById('pdp-main-image');
      if(mainImg) mainImg.src = img.src + '&width=900';
    }
  }
}
document.addEventListener('submit', function(e){
  if(e.target && e.target.getAttribute && e.target.getAttribute('id') === 'pdp-form'){
    e.preventDefault();
    const variantId = document.getElementById('pdp-variant-id').value;
    AOREX_addToCart(variantId, 1);
  }
});

function AOREX_setGalleryMode(mode, btnEl){
  document.querySelectorAll('.gallery-tab').forEach(b=>b.classList.remove('active'));
  if(btnEl) btnEl.classList.add('active');
  const mainImg = document.getElementById('pdp-main-image');
  if(!mainImg || !window.AOREX_PRODUCT) return;
  if(mode === 'onfoot' && window.AOREX_PRODUCT.metafields?.custom?.on_foot_image){
    mainImg.src = window.AOREX_PRODUCT.metafields.custom.on_foot_image;
  }
}

/* ---------------- ACCORDION ---------------- */
function AOREX_toggleAcc(i){
  const body = document.getElementById('acc-body-'+i);
  const open = body.style.display==='block';
  body.style.display = open ? 'none' : 'block';
  document.getElementById('acc-icon-'+i).textContent = open ? '+' : '−';
}
function AOREX_toggleFAQ(i){
  const body = document.getElementById('faq-body-'+i);
  const open = body.style.display==='block';
  body.style.display = open ? 'none' : 'block';
  document.getElementById('faq-icon-'+i).textContent = open ? '+' : '−';
}

/* ---------------- FIT CHECK: size converter (approximate standard men's chart) ---------------- */
const SIZE_CHART = [
  {uk:6,  us:7,   eu:39.5, cm:24.5},
  {uk:7,  us:8,   eu:40.5, cm:25.4},
  {uk:8,  us:9,   eu:42,   cm:26.2},
  {uk:9,  us:10,  eu:43,   cm:27.0},
  {uk:10, us:11,  eu:44.5, cm:27.9},
  {uk:11, us:12,  eu:45.5, cm:28.6},
];
function AOREX_openFitCheck(){ document.getElementById('fitcheck-modal-backdrop').style.display = 'flex'; }
function AOREX_closeFitCheck(){ document.getElementById('fitcheck-modal-backdrop').style.display = 'none'; }
function AOREX_showFitResult(row, note){
  const box = document.getElementById('fitcheck-result');
  box.style.display = 'block';
  box.innerHTML = `<div class="mono-tag" style="color:var(--red);margin-bottom:6px;">Recommended: AOREX UK${row.uk}</div>US ${row.us} · EU ${row.eu} · ${row.cm}cm${note?`<div style="color:var(--gray);margin-top:6px;">${note}</div>`:''}`;
}
function AOREX_fitFromCM(){
  const cm = parseFloat(document.getElementById('fitcheck-cm').value);
  document.getElementById('fitcheck-us').value = '';
  if(!cm || cm < 20 || cm > 33){ document.getElementById('fitcheck-result').style.display='none'; return; }
  let closest = SIZE_CHART[0];
  SIZE_CHART.forEach(row=>{ if(Math.abs(row.cm-cm) < Math.abs(closest.cm-cm)) closest = row; });
  const note = cm > closest.cm + 0.3 ? 'Closer to the next size up — consider sizing up if between sizes.' : '';
  AOREX_showFitResult(closest, note);
}
function AOREX_fitFromUS(){
  const us = parseFloat(document.getElementById('fitcheck-us').value);
  document.getElementById('fitcheck-cm').value = '';
  if(!us){ document.getElementById('fitcheck-result').style.display='none'; return; }
  let closest = SIZE_CHART[0];
  SIZE_CHART.forEach(row=>{ if(Math.abs(row.us-us) < Math.abs(closest.us-us)) closest = row; });
  AOREX_showFitResult(closest);
}

/* ---------------- PINCODE CHECKER: estimate only, based on India Post zone
   distance from the Nagpur origin. Not a live courier lookup. ---------------- */
function AOREX_checkPincode(){
  const raw = document.getElementById('pincode-input').value.trim();
  const box = document.getElementById('pincode-result');
  box.style.display = 'block';
  if(!/^[1-9][0-9]{5}$/.test(raw)){
    box.innerHTML = `<span style="color:var(--red);">Enter a valid 6-digit pincode.</span>`;
    return;
  }
  const zone = raw[0];
  let days, label;
  if(zone==='4'){ days='2–3 business days'; label='Same region as our Nagpur hub'; }
  else if(['3','5'].includes(zone)){ days='3–4 business days'; label='Neighbouring zone'; }
  else if(['1','2','6'].includes(zone)){ days='4–6 business days'; label='Cross-country'; }
  else if(['7','8'].includes(zone)){ days='5–7 business days'; label='Cross-country'; }
  else { days='7+ business days, may need extra handling'; label='Remote / special-handling area'; }
  box.innerHTML = `<span style="color:var(--off-white);">Estimated: <b>${days}</b></span><br><span style="color:var(--gray-dim);font-size:11px;">${label} · estimate only, confirmed at checkout</span>`;
}

/* ---------------- REVIEWS: real, locally-stored reviews. No seeded/fake reviews.
   NOTE: stored per-browser (localStorage) — there is no shared backend for this yet,
   so a review written on one device won't show to other visitors. Wire this to a
   real reviews app (Judge.me, Loox, etc.) before relying on it in production. ---------------- */
function AOREX_getReviews(productId){
  try{ return JSON.parse(localStorage.getItem('aorex_reviews_'+productId) || '[]'); }catch(e){ return []; }
}
function AOREX_escapeHTML(str){
  const div = document.createElement('div');
  div.textContent = str == null ? '' : String(str);
  return div.innerHTML;
}
function AOREX_renderReviews(){
  const wrap = document.getElementById('reviews-block');
  if(!wrap) return;
  const productId = wrap.dataset.productId;
  const reviews = AOREX_getReviews(productId);
  const avg = reviews.length ? (reviews.reduce((s,r)=>s+r.rating,0)/reviews.length) : 0;
  const stars = n => Array.from({length:5},(_,i)=>`<span style="color:${i<Math.round(n)?'var(--red)':'var(--border-strong)'};">★</span>`).join('');

  const summary = reviews.length
    ? `<div style="display:flex;align-items:center;gap:12px;margin-bottom:22px;">
        <span style="font-size:22px;">${stars(avg)}</span>
        <span class="mono-tag">${avg.toFixed(1)} · ${reviews.length} review${reviews.length>1?'s':''}</span>
      </div>`
    : `<p style="color:var(--gray);margin-bottom:22px;">No reviews yet — be the first to tell us how they fit.</p>`;

  const list = reviews.slice().reverse().map(r=>`
    <div style="border-top:1px solid var(--border);padding:16px 0;">
      <div style="display:flex;justify-content:space-between;align-items:center;">
        <span style="font-size:14px;">${stars(r.rating)}</span>
        <span class="mono-tag" style="font-size:10px;">${AOREX_escapeHTML(r.name)}</span>
      </div>
      <p style="color:var(--gray);margin-top:8px;font-size:14px;line-height:1.6;">${AOREX_escapeHTML(r.comment)}</p>
    </div>`).join('');

  wrap.innerHTML = `
    ${summary}
    <button class="btn" style="border:1px solid var(--border-strong);" onclick="AOREX_toggleReviewForm()">Write a Review</button>
    <div id="review-form" style="display:none;margin-top:18px;max-width:440px;">
      <div class="mono-tag" style="margin-bottom:6px;">Your Rating</div>
      <div id="review-star-input" style="font-size:24px;letter-spacing:4px;margin-bottom:14px;cursor:pointer;">${[1,2,3,4,5].map(i=>`<span data-star="${i}" onclick="AOREX_setReviewStars(${i})" style="color:var(--border-strong);">★</span>`).join('')}</div>
      <input id="review-name" type="text" placeholder="Your name" style="width:100%;background:var(--charcoal-2);border:1px solid var(--border);color:var(--off-white);padding:12px;border-radius:2px;font-size:14px;margin-bottom:10px;">
      <textarea id="review-comment" rows="3" placeholder="How's the fit, feel, comfort?" style="width:100%;background:var(--charcoal-2);border:1px solid var(--border);color:var(--off-white);padding:12px;border-radius:2px;font-size:14px;resize:vertical;"></textarea>
      <button class="btn btn-primary" style="margin-top:10px;" onclick="AOREX_submitReview('${productId}')">Submit Review</button>
    </div>
    ${list}
  `;
}
let AOREX_reviewStars = 0;
function AOREX_setReviewStars(n){
  AOREX_reviewStars = n;
  document.querySelectorAll('#review-star-input span').forEach(s=>{
    s.style.color = parseInt(s.dataset.star) <= n ? 'var(--red)' : 'var(--border-strong)';
  });
}
function AOREX_toggleReviewForm(){
  const f = document.getElementById('review-form');
  f.style.display = f.style.display === 'none' ? 'block' : 'none';
}
function AOREX_submitReview(productId){
  const name = document.getElementById('review-name').value.trim() || 'Anonymous';
  const comment = document.getElementById('review-comment').value.trim();
  if(!AOREX_reviewStars || !comment){ alert('Please add a star rating and a short comment.'); return; }
  const reviews = AOREX_getReviews(productId);
  reviews.push({name, comment, rating:AOREX_reviewStars, date:Date.now()});
  try{ localStorage.setItem('aorex_reviews_'+productId, JSON.stringify(reviews)); }catch(e){}
  AOREX_reviewStars = 0;
  AOREX_renderReviews();
}

/* ---------------- GAMIFICATION: first-visit scratch-reveal boarding perk.
   Shown once per browser. If a real discount code is configured in theme
   settings, this is a genuinely working code (unlike the static-site version). ---------------- */
function AOREX_closeScratchCard(){ document.getElementById('scratch-modal-backdrop').style.display = 'none'; }
function AOREX_revealScratch(){
  const cta = document.getElementById('scratch-cta');
  const reveal = document.getElementById('scratch-code-reveal');
  const panel = document.getElementById('scratch-panel');
  cta.style.transition = 'opacity .25s ease';
  cta.style.opacity = '0';
  setTimeout(()=>{
    cta.style.display = 'none';
    panel.style.background = 'var(--charcoal-2)';
    reveal.style.display = 'block';
    reveal.style.opacity = '0';
    reveal.style.transition = 'opacity .3s ease';
    requestAnimationFrame(()=>{ reveal.style.opacity = '1'; });
  }, 250);
}
function AOREX_maybeShowScratchCard(){
  let seen = true;
  try{ seen = !!localStorage.getItem('aorex_scratch_seen'); }catch(e){ return; }
  if(seen) return;
  const backdrop = document.getElementById('scratch-modal-backdrop');
  if(!backdrop) return;
  setTimeout(()=>{
    backdrop.style.display = 'flex';
    try{ localStorage.setItem('aorex_scratch_seen', '1'); }catch(e){}
  }, 1200);
}

/* ---------------- TOAST NOTIFICATIONS ---------------- */
function AOREX_showToast(message){
  let el = document.getElementById('aorex-toast');
  if(!el){
    el = document.createElement('div');
    el.id = 'aorex-toast';
    el.className = 'toast';
    el.innerHTML = '<svg class="toast-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg><span class="toast-msg"></span>';
    document.body.appendChild(el);
  }
  el.querySelector('.toast-msg').textContent = message;
  requestAnimationFrame(()=>{ el.classList.add('show'); });
  clearTimeout(window._aorexToastTimer);
  window._aorexToastTimer = setTimeout(()=>{ el.classList.remove('show'); }, 4000);
}

/* ---------------- NOTIFY MODAL ---------------- */
function AOREX_openNotifyModal(){ document.getElementById('notify-modal-backdrop').style.display = 'flex'; }
function AOREX_closeNotifyModal(){ document.getElementById('notify-modal-backdrop').style.display = 'none'; }

/* ---------------- FIND MY FIT QUIZ ---------------- */
const QUIZ_QUESTIONS = [
  { q:"Where does your day usually take you?",
    options:[
      { label:"Studio sessions and city streets", scores:{1:2, 2:1} },
      { label:"Long walks with no fixed destination", scores:{1:1, 2:2} },
      { label:"Everywhere, all in the same day", scores:{1:2, 2:2} },
    ]},
  { q:"How do you like your ankle support?",
    options:[
      { label:"Low profile, barely there", scores:{1:3} },
      { label:"A bit more structure and lockdown", scores:{2:3} },
    ]},
  { q:"Pick a pace.",
    options:[
      { label:"Fast, light, always moving", scores:{1:2} },
      { label:"Steady, grounded, built to last", scores:{2:2} },
    ]},
];
let AOREX_quizStep = 0;
let AOREX_quizScores = {};
function AOREX_openQuiz(){
  AOREX_quizStep = 0;
  AOREX_quizScores = {1:0, 2:0};
  document.getElementById('quiz-modal-backdrop').style.display = 'flex';
  AOREX_renderQuizStep();
}
function AOREX_closeQuiz(){ document.getElementById('quiz-modal-backdrop').style.display = 'none'; }
function AOREX_renderQuizStep(){
  const total = QUIZ_QUESTIONS.length;
  document.getElementById('quiz-progress-fill').style.width = Math.round((AOREX_quizStep/total)*100) + '%';
  const step = QUIZ_QUESTIONS[AOREX_quizStep];
  const dots = Array.from({length:total}).map((_,i)=>`<span class="${i<AOREX_quizStep?'done':''}"></span>`).join('');
  document.getElementById('quiz-body').innerHTML = `
    <div class="quiz-question">
      <div class="mono-tag">Question ${AOREX_quizStep+1} of ${total}</div>
      <h3>${step.q}</h3>
      <div class="quiz-options">
        ${step.options.map((o,i)=>`<button type="button" class="quiz-option" onclick="AOREX_answerQuiz(${i})">${o.label}</button>`).join('')}
      </div>
      <div class="quiz-dots">${dots}</div>
    </div>`;
}
function AOREX_answerQuiz(optionIndex){
  const step = QUIZ_QUESTIONS[AOREX_quizStep];
  const option = step.options[optionIndex];
  Object.entries(option.scores || {}).forEach(([pid,pts])=>{
    AOREX_quizScores[pid] = (AOREX_quizScores[pid]||0) + pts;
  });
  AOREX_quizStep++;
  if(AOREX_quizStep >= QUIZ_QUESTIONS.length){ AOREX_renderQuizResult(); }
  else{ AOREX_renderQuizStep(); }
}
function AOREX_renderQuizResult(){
  document.getElementById('quiz-progress-fill').style.width = '100%';
  const winnerId = AOREX_quizScores[1] >= AOREX_quizScores[2] ? 1 : 2;
  const template = document.getElementById('quiz-result-'+winnerId);
  document.getElementById('quiz-body').innerHTML = (template && template.innerHTML.trim()) ? template.innerHTML : '<p style="padding:20px;color:var(--gray);">Set the two quiz outcome products in the theme editor (Theme Settings → Find My Fit Quiz) to enable this result.</p>';
}

/* ---------------- SEARCH (Shopify's real predictive search) ---------------- */
function AOREX_openSearch(){
  document.getElementById('search-modal-backdrop').style.display = 'flex';
  setTimeout(()=>document.getElementById('search-input').focus(), 50);
}
function AOREX_closeSearch(){ document.getElementById('search-modal-backdrop').style.display = 'none'; }
let AOREX_searchDebounce;
function AOREX_runSearch(query){
  clearTimeout(AOREX_searchDebounce);
  const resultsEl = document.getElementById('search-results');
  const q = query.trim();
  if(q.length < 2){
    resultsEl.innerHTML = `<p class="mono-tag" style="padding:16px 20px;">Try "voyager", "shipping", or a size like "UK9".</p>`;
    return;
  }
  AOREX_searchDebounce = setTimeout(async ()=>{
    try{
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article&resources[limit]=6`);
      const data = await res.json();
      const products = (data.resources.results.products||[]);
      const pages = (data.resources.results.pages||[]);
      const articles = (data.resources.results.articles||[]);
      if(!products.length && !pages.length && !articles.length){
        resultsEl.innerHTML = `<p class="mono-tag" style="padding:16px 20px;">No matches for "${query}". Try a different word.</p>`;
        return;
      }
      let html = '';
      if(products.length){
        html += `<div class="mono-tag" style="padding:10px 20px 4px;">Products</div>`;
        html += products.map(p=>`
          <a class="search-result-row" href="${p.url}" style="display:flex;align-items:center;gap:12px;padding:10px 20px;">
            ${p.featured_image ? `<img src="${p.featured_image.url}&width=80" style="width:38px;height:38px;object-fit:cover;flex-shrink:0;">` : ''}
            <span><strong>${p.title}</strong><span class="mono-tag" style="display:block;">${p.price}</span></span>
          </a>`).join('');
      }
      if(pages.length || articles.length){
        html += `<div class="mono-tag" style="padding:10px 20px 4px;">Pages</div>`;
        html += [...pages, ...articles].map(pg=>`
          <a class="search-result-row" href="${pg.url}" style="display:block;padding:10px 20px;">
            <strong>${pg.title}</strong>
          </a>`).join('');
      }
      resultsEl.innerHTML = html;
    }catch(e){
      resultsEl.innerHTML = `<p class="mono-tag" style="padding:16px 20px;">Search is temporarily unavailable.</p>`;
    }
  }, 250);
}

/* ---------------- DECORATIVE: reveal-on-scroll, marquee, barcode ---------------- */
function AOREX_observeReveals(){
  try{
    const els = document.querySelectorAll('.reveal');
    if(!('IntersectionObserver' in window)){ els.forEach(el=>el.classList.add('in')); return; }
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    }, {threshold:0.15});
    els.forEach(el=>io.observe(el));
  }catch(e){ /* never let decorative JS break navigation */ }
}
function AOREX_renderBarcode(id){
  const el = document.getElementById(id);
  if(!el) return;
  let bars = '';
  for(let i=0;i<40;i++){ bars += `<span style="height:${6+Math.random()*16}px;"></span>`; }
  el.innerHTML = bars;
}
function AOREX_renderMarquee(){
  const el = document.getElementById('marquee-track');
  if(!el) return;
  const phrase = `<span>MOVE DIFFERENT <em>·</em> NO FIXED ROUTE <em>·</em> CHASE WHAT'S NEXT <em>·</em> STAY AOREX <em>·</em></span>`;
  el.innerHTML = phrase.repeat(4);
}

/* ---------------- INIT ---------------- */
document.addEventListener('DOMContentLoaded', ()=>{
  AOREX_applyTheme();
  AOREX_renderCartCount();
  AOREX_renderWishlistCount();
  AOREX_observeReveals();
  AOREX_renderBarcode('hero-barcode');
  AOREX_renderMarquee();
  AOREX_initVariantPicker();
  AOREX_renderReviews();
  AOREX_maybeShowScratchCard();

  document.querySelectorAll('[data-wishlist-toggle]').forEach(btn=>{
    const id = parseInt(btn.dataset.wishlistToggle, 10);
    if(AOREX_getWishlist().some(x=>x.id===id)) btn.classList.add('active');
  });
});
